import React from "react";
import {
  Bar,
  BarChart,
  Cell,
  ResponsiveContainer,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";
import { useNavigate } from "react-router";
import { currencyFormat } from "utils";
import DashboardCard from '../../common/DashboardCard';
import { Box, Typography } from '@mui/material';
import ElectricCarIcon from '@mui/icons-material/ElectricCar';

const CustomizedLabel = ({ x, y, fill, value }: any) => {
  return (
    <text
      x={x + 60}
      y={y + 30}
      dy={-4}
      fontSize="20"
      fontWeight={"bold"}
      fill={"white"}
      textAnchor="middle"
    >
      {currencyFormat(value)}
    </text>
  );
};
const COLORS = ["#BEF213", "#4B6105"];



function ChargingSummaryBarChart(props: any) {
  const data = props.data;
  const dashboardInfo = props.dashboardInfo;
  const fleetScenarioUuid = props.fleetScenarioUuid;
  const accentColor = props.accentColor;
  const navigate = useNavigate();
  const savings = Math.round(dashboardInfo.currentMonth?.costSaving);
  
  return (
    <DashboardCard
      title="Public Charging Cost Comparison (£)"
      icon={<ElectricCarIcon />}
      accentColor={accentColor}
    >
      <Box sx={{ width: '100%', height: 400, position: 'relative' }}>
        <ResponsiveContainer>
          <BarChart
            data={data}
            margin={{
              top: 20,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip formatter={(value) => `£${value}`} />
            <Legend />
            <Bar dataKey="price" fill="#8884d8" name="Cost" />
          </BarChart>
        </ResponsiveContainer>
        <Typography 
          variant="subtitle1" 
          color="success.main" 
          sx={{ 
            position: 'absolute', 
            bottom: 0, 
            left: '50%', 
            transform: 'translateX(-50%)',
            fontWeight: 500
          }}
        >
          You've saved approx. £{savings} this month
        </Typography>
      </Box>
      {/* <button style={{ marginTop: 20 }} className="primary-btn" onClick={() => (navigate("/plan/insight/fleet/scenario/categories", {
                state: {
                    scenarioUuid: props.fleetScenarioUuid
                }
            }))}>View</button> */}
    </DashboardCard>
  );
}

export default ChargingSummaryBarChart;
